var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumSpiceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_244_169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5512 6.97363C17.1725 5.86244 17.1264 4.44986 16.3876 3.40961C16.336 3.33494 16.2701 3.27122 16.1938 3.22212C16.1174 3.17302 16.0321 3.13952 15.9428 3.12354C15.8534 3.10756 15.7618 3.10942 15.6732 3.12901C15.5845 3.1486 15.5006 3.18554 15.4264 3.23769C15.1145 3.45709 15.0372 3.89057 15.2557 4.20499C15.6729 4.80603 15.6937 5.58572 15.3743 6.22498C14.8748 5.98636 14.3218 5.8416 13.7428 5.8416C12.6939 5.8416 11.7471 6.24201 11.0143 6.88156L13.2796 7.87983V10.5H15.9015L16.8722 12.7649C17.5124 12.0316 17.9119 11.0848 17.9119 10.0107C17.9119 8.82078 17.3821 7.73797 16.5512 6.97363ZM12.3531 11.4265V8.49072L10.8201 7.8338C9.34785 10.0744 8.54587 14.6691 4.7097 14.6691C3.81595 14.6691 3.08838 15.3958 3.08838 16.2904C3.08838 17.1851 3.81595 17.9118 4.7097 17.9118C9.92979 17.9118 13.9773 15.3562 15.9808 13.0333L15.2917 11.4265H12.3531Z",
    fill: "#FFA400"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 9.5,
    stroke: "#FFA400",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_244_169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8235,
    height: 14.8235,
    fill: "white",
    transform: "translate(3.08838 3.08813)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumSpiceIcon);
export default __webpack_public_path__ + "static/media/medium-spice-icon.0be867ca9c99dbc3d888286d4120314c.svg";
export { ForwardRef as ReactComponent };